import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Typography } from '@emburse/ui-core';
export const PrivacyPolicy = () => {
    var _a, _b;
    const policyFragment = (_b = (_a = window.whitelabelConfiguration) === null || _a === void 0 ? void 0 : _a.fragments) === null || _b === void 0 ? void 0 : _b.privacyPolicy;
    if (!policyFragment) {
        return null;
    }
    return (_jsx(Typography, Object.assign({ variant: "body2", color: "textSecondary", align: "center" }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: policyFragment } }) })));
};
